<template>
  <FormularioCadastro
    module-name="Tipos de Imagem"
    :is-loading="isLoading"
    :is-editing="isEditing"
    :entity-info="entityInfo"
    @submit="salvar"
    @cancelar="handleCancel"
  >
    <div class="card mb-4">
      <div class="card-header bg-body-tertiary">
        <h5 class="mb-0"><i class="bi bi-info-circle me-2 text-primary"></i> Dados do Tipo de Imagem</h5>
      </div>
      <div class="card-body">
        <div class="row g-3">
          <div class="col-md-4">
            <CampoInput
              id="tipoImagem"
              label="Código"
              v-model="item.tipoImagem"
              :disabled="isEditing"
              placeholder="Ex: LOGO_RELATORIO"
              descricao-informativa="Código único identificador. Use letras maiúsculas e underscores. Não pode ser alterado após a criação."
              required
            />
          </div>

          <div class="col-md-4">
            <CampoInput
              id="nomeAmigavel"
              label="Nome Amigável"
              v-model="item.nomeAmigavel"
              placeholder="Ex: Logo para Relatório"
              required
            />
          </div>

          <div class="col-md-4">
            <CampoInput
              id="ordemExibicao"
              label="Ordem de Exibição"
              type="number"
              min="0"
              v-model.number="item.ordemExibicao"
              descricao-informativa="Ordem em que este tipo aparece na tela de upload."
            />
          </div>

          <div class="col-12">
            <CampoInput
              id="descricao"
              label="Descrição"
              type="textarea"
              v-model="item.descricao"
              placeholder="Descreva a finalidade deste tipo de imagem"
              required
            />
          </div>
        </div>
      </div>
    </div>

    <div class="card mb-4">
      <div class="card-header bg-body-tertiary">
        <h5 class="mb-0"><i class="bi bi-rulers me-2 text-primary"></i> Restrições de Dimensão</h5>
      </div>
      <div class="card-body">
        <p class="text-muted small mb-3">
          <i class="bi bi-info-circle me-1"></i>
          Defina as dimensões mínimas, máximas e proporção esperada. Deixe em branco para não aplicar restrição.
        </p>
        <div class="row g-3">
          <div class="col-md-3">
            <CampoInput
              id="larguraMinima"
              label="Largura Mínima (px)"
              type="number"
              min="0"
              v-model.number="item.larguraMinima"
            />
          </div>
          <div class="col-md-3">
            <CampoInput
              id="alturaMinima"
              label="Altura Mínima (px)"
              type="number"
              min="0"
              v-model.number="item.alturaMinima"
            />
          </div>
          <div class="col-md-3">
            <CampoInput
              id="larguraMaxima"
              label="Largura Máxima (px)"
              type="number"
              min="0"
              v-model.number="item.larguraMaxima"
            />
          </div>
          <div class="col-md-3">
            <CampoInput
              id="alturaMaxima"
              label="Altura Máxima (px)"
              type="number"
              min="0"
              v-model.number="item.alturaMaxima"
            />
          </div>
        </div>

        <hr class="my-3">
        <h6 class="text-muted text-uppercase small fw-bold mb-3">Proporção (Aspect Ratio)</h6>
        <div class="row g-3">
          <div class="col-md-3">
            <CampoInput
              id="proporcaoLargura"
              label="Proporção - Largura"
              type="number"
              min="1"
              v-model.number="item.proporcaoLargura"
              placeholder="Ex: 16"
            />
          </div>
          <div class="col-md-3">
            <CampoInput
              id="proporcaoAltura"
              label="Proporção - Altura"
              type="number"
              min="1"
              v-model.number="item.proporcaoAltura"
              placeholder="Ex: 9"
            />
          </div>
          <div class="col-md-6 d-flex align-items-end pb-3">
            <span v-if="item.proporcaoLargura && item.proporcaoAltura" class="badge badge-ghost-info fs-6 px-3 py-2">
              {{ item.proporcaoLargura }}:{{ item.proporcaoAltura }}
            </span>
            <span v-else class="text-muted small">Sem restrição de proporção</span>
          </div>
        </div>
      </div>
    </div>

    <div class="card mb-4">
      <div class="card-header bg-body-tertiary">
        <h5 class="mb-0"><i class="bi bi-file-earmark me-2 text-primary"></i> Configurações de Arquivo</h5>
      </div>
      <div class="card-body">
        <div class="row g-3">
          <div class="col-md-6">
            <CampoInput
              id="formatosPermitidos"
              label="Formatos Permitidos"
              v-model="item.formatosPermitidos"
              placeholder="Ex: png,jpg,jpeg"
              descricao-informativa="Lista de extensões separadas por vírgula. Ex: png,jpg,jpeg,gif,svg"
            />
          </div>
          <div class="col-md-6">
            <CampoInput
              id="dimensaoRecomendada"
              label="Dimensão Recomendada"
              v-model="item.dimensaoRecomendada"
              placeholder="Ex: 1920x1080px"
              descricao-informativa="Texto informativo exibido ao usuário sobre a dimensão ideal."
            />
          </div>
        </div>
      </div>
    </div>

    <div class="card mb-4">
      <div class="card-header bg-body-tertiary">
        <h5 class="mb-0"><i class="bi bi-info-square me-2 text-primary"></i> Informações ao Usuário</h5>
      </div>
      <div class="card-body">
        <div class="row g-3">
          <div class="col-12">
            <CampoInput
              id="instrucoesCliente"
              label="Instruções ao Cliente"
              type="textarea"
              v-model="item.instrucoesCliente"
              placeholder="Ex: Envie um arquivo com fundo transparente para melhor resultado."
              descricao-informativa="Texto de ajuda exibido ao lado do campo de upload."
            />
          </div>
          <div class="col-12">
            <CampoInput
              id="exemploVisual"
              label="URL do Exemplo Visual"
              v-model="item.exemploVisual"
              placeholder="https://exemplo.com/exemplo.png"
              descricao-informativa="URL de uma imagem de exemplo para referência do usuário."
            />
          </div>
        </div>
      </div>
    </div>

    <div class="card mb-4">
      <div class="card-header bg-body-tertiary">
        <h5 class="mb-0"><i class="bi bi-toggle-on me-2 text-primary"></i> Configurações de Comportamento</h5>
      </div>
      <div class="card-body">
        <div class="row g-3">
          <div class="col-md-6">
            <div class="form-check form-switch mt-2">
              <input class="form-check-input cursor-pointer" type="checkbox" id="obrigatorio" v-model="item.obrigatorio">
              <label class="form-check-label cursor-pointer" for="obrigatorio">
                <span class="fw-medium">Obrigatório</span><br>
                <small class="text-muted">Se ativo, a empresa será obrigada a enviar esta imagem.</small>
              </label>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-check form-switch mt-2">
              <input class="form-check-input cursor-pointer" type="checkbox" id="ativo" v-model="item.ativo">
              <label class="form-check-label cursor-pointer" for="ativo">
                <span class="fw-medium">Ativo</span><br>
                <small class="text-muted">Tipos inativos não aparecem na tela de upload.</small>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </FormularioCadastro>
</template>

<script setup>
import { useFormulario } from '@/composables/useFormulario.js'
import FormularioCadastro from '@/components/base/formulario/FormularioCadastro.vue'
import CampoInput from '@/components/base/campos/CampoInput.vue'

const props = defineProps({
  itemParaEditar: {
    type: Object,
    default: null
  },
  modeloVazio: {
    type: Object,
    default: () => ({
      tipoImagem: '',
      nomeAmigavel: '',
      descricao: '',
      exemploVisual: '',
      larguraMinima: null,
      alturaMinima: null,
      larguraMaxima: null,
      alturaMaxima: null,
      proporcaoLargura: null,
      proporcaoAltura: null,
      formatosPermitidos: '',
      dimensaoRecomendada: '',
      instrucoesCliente: '',
      ordemExibicao: 0,
      obrigatorio: false,
      ativo: true,
      xmin: 0
    })
  }
})

const emit = defineEmits(['itemAtualizado', 'cancelar', 'show-notification'])

const {
  item,
  isLoading,
  isEditing,
  entityInfo
} = useFormulario(props, emit, { idKey: 'tipoImagem' })
</script>
